.page {
  min-height: 100vh;
  background: var(--mantine-color-body);
  color: var(--mantine-color-text);
}

/* Big tile-style CTAs — way more clickable than a button buried under a form.
   Uses flex justify-between so the arrow sits on the far edge as a target hint. */
.ctaTile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 20px 24px;
  border-radius: 14px;
  border: 1px solid transparent;
  text-decoration: none;
  cursor: pointer;
  transition:
    transform 220ms ease,
    box-shadow 220ms ease;
}

.ctaTile:hover {
  transform: translateY(-3px);
  text-decoration: none;
}

.ctaWhatsapp {
  background: light-dark(
    linear-gradient(135deg, #25d366 0%, #128c7e 100%),
    linear-gradient(135deg, #128c7e 0%, #075e54 100%)
  );
  color: white;
  box-shadow: light-dark(0 12px 32px -8px rgba(37, 211, 102, 0.45), 0 12px 32px -8px rgba(0, 0, 0, 0.55));
}

.ctaWhatsapp:hover {
  box-shadow: light-dark(0 18px 42px -8px rgba(37, 211, 102, 0.55), 0 18px 42px -8px rgba(0, 0, 0, 0.65));
}

.ctaTeal {
  background: light-dark(
    linear-gradient(135deg, var(--mantine-color-teal-6) 0%, var(--mantine-color-teal-7) 100%),
    linear-gradient(135deg, var(--mantine-color-teal-7) 0%, var(--mantine-color-teal-9) 100%)
  );
  color: white;
  box-shadow: light-dark(0 12px 32px -8px rgba(31, 124, 106, 0.45), 0 12px 32px -8px rgba(0, 0, 0, 0.55));
}

.ctaTeal:hover {
  box-shadow: light-dark(0 18px 42px -8px rgba(31, 124, 106, 0.55), 0 18px 42px -8px rgba(0, 0, 0, 0.65));
}

.ctaSubtle {
  color: rgba(255, 255, 255, 0.85);
}

.ctaArrow {
  color: white;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* Secondary info tiles — quieter than CTAs */
.infoTile {
  background: light-dark(white, var(--mantine-color-dark-7));
  border-color: light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-5));
  text-decoration: none;
  color: inherit;
  transition: border-color 180ms ease;
}

.infoTile:hover {
  border-color: light-dark(var(--mantine-color-teal-3), var(--mantine-color-teal-7));
  text-decoration: none;
}
